export default __webpack_public_path__ + "static/media/1934.17b99dd3.png";